import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addTier: {
    id: 'app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.TechCheckStage.Requirements.addTier',
    defaultMessage: 'Add another requirement tier',
  },
});
